import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var FlipbackFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement(SvgFill, {
    d: "M13 38.047a2 2 0 0 0 1.527 1.943l14 3.408A2 2 0 0 0 31 41.455v-5.25c-2.73.627-5.783.976-9 .976-3.215 0-6.27-.349-9-.977v1.843ZM12.23 33.949a27.337 27.337 0 0 1-1.897-.592.996.996 0 0 0-.489-.045 26.992 26.992 0 0 1-3.102-1.155c-1.977-.886-3.638-1.966-4.819-3.217C.738 27.684 0 26.213 0 24.591c0-3.12 2.676-5.642 6.299-7.36a1 1 0 0 1 .857 1.806C3.677 20.687 2 22.71 2 24.591c0 .977.438 1.98 1.377 2.976.945 1.001 2.36 1.948 4.183 2.765 1.566.702 3.403 1.293 5.44 1.74v-.05c2.73.63 5.785.978 9 .978 3.217 0 6.27-.35 9-.977v.049c2.037-.447 3.874-1.038 5.44-1.74 1.824-.817 3.238-1.764 4.183-2.765.94-.995 1.377-2 1.377-2.976 0-1.168-.63-2.384-1.996-3.566-.977-.845-2.289-1.63-3.882-2.314l1.786 3.87a1 1 0 0 1-1.816.838l-3.524-7.635 8.223-1.762a1 1 0 1 1 .419 1.956l-4.26.912c1.723.743 3.206 1.623 4.362 2.623C42.94 20.92 44 22.643 44 24.59c0 1.622-.738 3.093-1.923 4.35-1.18 1.25-2.842 2.33-4.819 3.216a28.303 28.303 0 0 1-4.215 1.475.998.998 0 0 0-.34.045 28.69 28.69 0 0 1-.93.27c-.254.06-.512.115-.773.17v.031c-2.678.658-5.74 1.033-9 1.033-3.261 0-6.323-.375-9-1.033v-.032c-.26-.053-.516-.11-.77-.167Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M31 29.967V5.953a2 2 0 0 0-1.527-1.943l-14-3.408A2 2 0 0 0 13 2.545v27.422c2.677.657 5.739 1.033 9 1.033 3.26 0 6.322-.375 9-1.033Z"
  })));
});
FlipbackFill.displayName = 'FlipbackFill';
FlipbackFill.defaultProps = {
  'aria-label': 'FlipbackFill'
};
export default FlipbackFill;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/FlipBackFill.js
// module id = 3167
// module chunks = 11